// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3OCad","header":"ReportDetails_header__7nLAZ","title":"ReportDetails_title__3iUcD","left":"ReportDetails_left__2dazp"};